import { render, staticRenderFns } from "./FastSelect.vue?vue&type=template&id=5ed32ed6&scoped=true&"
import script from "./FastSelect.vue?vue&type=script&lang=ts&"
export * from "./FastSelect.vue?vue&type=script&lang=ts&"
import style0 from "./FastSelect.vue?vue&type=style&index=0&id=5ed32ed6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed32ed6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VContainer})
